export default __webpack_public_path__ + "locales/pt/FormFillingTipsDialog.json?hash=18564e500edca88b33406f59e2754cde";